/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { termsEditorCategories } from "../terms/categories";

/**
 * Component category
 */
export interface IComponentCategory {
	label: string;
	order: number;
}

/**
 * Map of component category name to it's info
 */
export type TComponentCategoryMap = { [K: string]: IComponentCategory };

export const ComponentCategories: TComponentCategoryMap = {
	content: {
		label: termsEditorCategories.component.content.label,
		order: 10
	},
	form: {
		label: termsEditorCategories.component.form.label,
		order: 20
	},
	layout: {
		label: termsEditorCategories.component.layout.label,
		order: 30
	},
	charts: {
		label: termsEditorCategories.component.charts.label,
		order: 40
	},
	navigation: {
		label: termsEditorCategories.component.navigation.label,
		order: 50
	},
	logic: {
		label: termsEditorCategories.component.logic.label,
		order: 60
	},
	fluentUi: {
		label: termsEditorCategories.component.fluentUi.label,
		order: 80
	},
	test: {
		label: termsEditorCategories.component.test.label,
		order: 100
	}
};
